import { AppDispatch } from '@app-types/appStorageType';
import httpClient, { apiCall } from '@commands/httpClient';
import { loadPurchaseLessonAction, loadPurchaseHistoryAction } from '@modules/investments/purchases/actions';
import { ResultListRes } from '@modules/apiClient/type';
import { IPurchase, Purchase } from '@modules/investments/purchases/types/purchase';
import { StageLesson } from '@modules/investments/products/types/stage';
import { PurchaseResp } from '@commands/purchase/types';

export const createPurchase = (stageId: number, code?: string, teacherId?: number) => (_: AppDispatch<object>) => {
  _(httpClient<object, PurchaseResp>(`/v1/purchase/`, {
    stageId,
    code,
    teacherId,
  }, { method: 'post', context: 'main' }))
    .then(res => {
      if (window) {
        window.location.href = res.url || '/pay/error';
      }
      return res;
    });
};

export const loadPurchase = () => (_: AppDispatch<object>) =>
  _(httpClient<object, ResultListRes<IPurchase[]>>(`/v1/purchase/list`, undefined, { method: 'get', context: 'main' }))
    .then(({ list }) => {
      const items = (list || []).map(purchase => {
        const stage = new StageLesson(purchase.stage!);
        return new Purchase<StageLesson>(purchase, stage);
      });

      _(loadPurchaseLessonAction(items));

      return items.length > 0;
    });

// TODO Safe remove
export const loadPurchaseHistory = () => (_: AppDispatch<object>) =>
  _(httpClient<object, ResultListRes<IPurchase[]>>(`/v1/purchase/refill-list`, undefined, { method: 'get', context: 'main' }))
    .then(({ list }) => {
      const items = (list || []).map(purchase => {
        const stage = new StageLesson(purchase.stage!);
        return new Purchase<StageLesson>(purchase, stage);
      });

      _(loadPurchaseHistoryAction(items));

      return items.length > 0;
    });

export const createPurchaseToUser = (stageId: number, userId: number) => (_: AppDispatch<object>) => {
  return _(apiCall<object, PurchaseResp>(`/v1/purchase/admin`, {
    stageId,
    userId,
  }, { method: 'post' }));
};

export const loadPurchaseFromUser = (userId: number) => (_: AppDispatch<ResultListRes<IPurchase[]>>) =>
  _(apiCall<object, ResultListRes<IPurchase[]>>(`/v1/purchase/admin/list/${userId}`, undefined, {
    method: 'get',
    context: 'main',
  }))
    .then(({ list }) => {
      const items = (list || []).map(purchase => {
        const stage = new StageLesson(purchase.stage!);
        return new Purchase<StageLesson>(purchase, stage, purchase.category);
      });

      _(loadPurchaseLessonAction(items));

      return items.length > 0;
    });
